import { Box, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

import Icon from '@src/components/shared/Icon'

import { CalendarEventType } from './Calendar'
const useStyles = makeStyles()((theme) => ({
  eventText: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.common.white,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'pointer',
  },
  campaignStart: {
    background: theme.palette.success.main,
  },
  campaignEnd: {
    background: theme.palette.error.main,
  },
  automation: {
    background: '#3f51b5',
  },
  scheduled_share: {
    background: '#ffc208',
  },
  executed_share: {
    background: '#9b26af',
  },
}))
interface CalendarEventProps {
  event: CalendarEventType
  onClose?: () => void
}

const CalendarEvent: React.FC<React.PropsWithChildren<CalendarEventProps>> = ({
  event: calendarEvent,
}) => {
  const { classes, cx } = useStyles()

  return (
    <div>
      <Box
        display="flex"
        flexWrap="nowrap"
        paddingX={1}
        paddingY={0.25}
        mb={0.5}
        className={cx(
          classes.eventText,
          calendarEvent.type === 'campaign'
            ? calendarEvent.isStart
              ? classes.campaignStart
              : classes.campaignEnd
            : classes[calendarEvent.type],
        )}
        borderRadius="4px"
      >
        {calendarEvent.channel && (
          <Box
            marginRight=".5rem"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Icon
              color={'white'}
              size={15}
              icon={
                calendarEvent.channel === 'email_shares'
                  ? 'email_open'
                  : calendarEvent.channel.replace('_shares', '')
              }
            />
          </Box>
        )}
        <Typography noWrap variant="caption">
          {calendarEvent.title}
        </Typography>
      </Box>
    </div>
  )
}

export default CalendarEvent
